<template>
	<div>
		<div style="position: relative;;height:calc(90vh - 180px);width: 100%;overflow-y: auto;overflow-x: hidden;">
			<cForm ref="form" :fields="form.fields" :config="form.config" :grid="form.grid"></cForm>
			<Packing :list="packing"></Packing>
			<Goods read :list="goods"></Goods>
		</div>
		<div style="text-align: right;margin-top: 20px;">
			<Button type="primary" @click="save">{{$t('save')+$t('detail')}}</Button>
		</div>
	</div>
  <!-- <div style="position: relative; height:600px">
    <div v-if="loading" class="loading-div">
      <Button loading shape="circle" type="primary"></Button>
      <div>loading...</div>
    </div> -->
	
  <!-- </div> --> 
</template>

<script>
import {
  getIncome,
  addIncome,
  updateIncome,
  deleteIncome,
  getIncomeWeight,
} from "@/api/tracker/income";
import { getConfig } from "@/api/tracker/cost_page";
import { getExpense } from "@/api/finance/expense";
import cTable from "@/base/common/index";
import Packing from '../newAirWaybillN/packing.vue'
import cForm from "@/base/common/component/form";
import Goods from '../warehousing/goods'
import { Mul } from "@/libs/tools";
import numFun from "@/utils/numFun";
export default {
  components: {
		Packing,
		Goods,
		cForm,
  },
	inject:['$page'],
  props: {
    rows: {
      type: Object,
    },
		form:{
			type:Object,
		},
		height:{
			type:Number,
			default:300
		}
  },
	methods:{
		save(){
			let modal = this.$page.getModal('update')
			modal.params["method"] = "put";
			this.$page.handleRequestMethods("list", modal.params, true).then((e) => {
				this.$page.getList();
				modal.close();
			});
		}
	},
  data() {
    let that = this;
    return {
			packing:[],
			goods:[],
      methods: {
        
      },
      config: {
        height: this.height,
        slot: "div",
        resize: false,
        showOverflow: false,
      },
      footer: {
        show: () => false,
      },
      fields: [
				{
					name: () => this.$t("packing_number"),
					key: "packing_number",
					tooltip: true,
					minWidth: 100,
				},
				{
					name: () => this.$t("number_of_bags"),
					key: "quantity",
					tooltip: true,
					minWidth: 100,
				},
				{
					name: () => this.$t("skuVolume"),
					key: "volume",
					tooltip: true,
					minWidth: 100,
				},
				{
					name: () => this.$t("invoiceWeight"),
					key: "weight",
					tooltip: true,
					minWidth: 100,
				},
			],
    };
  },
  mounted() {
    this.$nextTick(()=>{
			this.$refs["form"].setFormData(this.rows)
			this.packing = this.rows.packing.packing
			this.goods = this.rows.packing.goods
		})
  },
};
</script>
